module.exports = __webpack_public_path__ + "cf.logo.83ca4.svg";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/cloudfoundry/logo/cf.logo.svg
// module id = 3974
// module chunks = 0